import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Language, translations } from './thi-translations';
import { normalizeThiLang } from './thi-lang.util';

@Component({
  selector: 'app-thi-landing-footer',
  templateUrl: './thi-landing-footer.component.html',
  styleUrls: ['./thi-landing-footer.component.scss'],
})
export class ThiLandingFooterComponent implements OnInit, OnChanges {
  @Input() lang: Language = 'ar';
  t = translations.ar;
  year = new Date().getFullYear();

  ngOnInit(): void {
    this.applyLang();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lang']) {
      this.applyLang();
    }
  }

  private applyLang(): void {
    this.lang = normalizeThiLang(this.lang as unknown as string);
    this.t = translations[this.lang];
  }
}
